import type { WeeklyReimbursementsFilterState } from '../../types/filters'
import type { WeeklyReimbursementsReportListParams } from '../../types/pages'
import { getRolling52WeekRange } from '../../utils/reportRolling52Weeks'

export const DEFAULT_FILTER: WeeklyReimbursementsFilterState = {
  year: 'Rolling 52 Weeks',
  ...getRolling52WeekRange(),
  week_filter: [],
}

export const DEFAULT_PARAMS: WeeklyReimbursementsReportListParams = {
  ...DEFAULT_FILTER,
  page: 1,
  perPage: 50,
  sortBy: 'desc',
  orderBy: 'created_at',
}
